(function ($) {
    function parseSettings($root) {
        try {
            return JSON.parse($root.attr("data-settings") || "{}");
        } catch (e) {
            return {};
        }
    }

    function initListing($root) {
        var settings = parseSettings($root);

        var restBase =
            window.PenegaListingPosts && window.PenegaListingPosts.restBase
                ? window.PenegaListingPosts.restBase
                : "";

        var $grid = $root.find(".listing__grid").first();
        var $pagination = $root.find(".listing__pagination").first();
        var $btnReset = $root.find(".filters__reset").first();
        var $searchInput = $root.find(".listing__search-input").first();

        if (!restBase || !$grid.length) return;

        var state = {
            page: 1,
            maxPages: 1,
            loading: false,
            search: "",
            excluded: {}, // { taxonomy: [termId, ...] }
            selected: {}, // { taxonomy: { termId: true } }
        };

        // --- URL sync helpers ---
        function readSelectedFromUrl() {
            var selected = {};
            try {
                var url = new URL(window.location.href);
                url.searchParams.forEach(function (value, key) {
                    // expecting: filters[taxonomy]=1,2,3
                    var m = key.match(/^filters\[([^\]]+)\]$/);
                    if (!m) return;

                    var tax = String(m[1] || "").trim();
                    if (!tax) return;

                    var ids = String(value || "")
                    .split(",")
                    .map(function (s) {
                        return String(s).trim();
                    })
                    .filter(function (s) {
                        return s && /^\d+$/.test(s);
                    });

                    if (!ids.length) return;

                    if (!selected[tax]) selected[tax] = {};
                    ids.forEach(function (id) {
                        selected[tax][id] = true;
                    });
                });
            } catch (e) {
                return {};
            }
            return selected;
        }

        function readSearchFromUrl() {
            try {
                var url = new URL(window.location.href);
                return String(url.searchParams.get("search") || "").trim();
            } catch (e) {
                return "";
            }
        }

        function readExcludedFromUrl() {
            var excluded = {};
            try {
                var url = new URL(window.location.href);
                url.searchParams.forEach(function (value, key) {
                    var m = key.match(/^exclude\[([^\]]+)\]$/);
                    if (!m) return;

                    var tax = String(m[1] || "").trim();
                    if (!tax) return;

                    var ids = String(value || "")
                    .split(",")
                    .map(function (s) {
                        return parseInt(String(s).trim(), 10);
                    })
                    .filter(function (id) {
                        return id > 0;
                    });

                    if (ids.length) {
                        excluded[tax] = ids;
                    }
                });
            } catch (e) {
                return {};
            }
            return excluded;
        }

        function writeSelectedToUrl(push) {
            try {
                var url = new URL(window.location.href);

                // remove existing filters[...]
                var keysToDelete = [];
                url.searchParams.forEach(function (_v, k) {
                    if (/^filters\[/.test(k)) keysToDelete.push(k);
                });
                keysToDelete.forEach(function (k) {
                    url.searchParams.delete(k);
                });
                url.searchParams.delete("search");

                // add current selection
                $.each(state.selected, function (tax, map) {
                    var ids = [];
                    $.each(map, function (termId, on) {
                        if (on) ids.push(String(termId));
                    });

                    if (ids.length) {
                        ids.sort(function (a, b) {
                            return parseInt(a, 10) - parseInt(b, 10);
                        });
                        url.searchParams.set("filters[" + tax + "]", ids.join(","));
                    }
                });

                $.each(state.excluded, function (tax, ids) {
                    if (!ids || !ids.length) return;
                    url.searchParams.set("exclude[" + tax + "]", ids.join(","));
                });

                if (state.search) {
                    url.searchParams.set("search", state.search);
                }

                var newUrl =
                    url.pathname +
                    (url.searchParams.toString() ? "?" + url.searchParams.toString() : "") +
                    url.hash;

                if (push) window.history.pushState({ penegaListingPosts: true }, "", newUrl);
                else window.history.replaceState({ penegaListingPosts: true }, "", newUrl);
            } catch (e) {
                // ignore URL errors
            }
        }
        // --- end URL sync helpers ---

        function setSelected(tax, termId, on) {
            if (!state.selected[tax]) state.selected[tax] = {};
            state.selected[tax][termId] = !!on;
        }

        function clearSelected() {
            state.selected = {};
        }

        function clearTaxonomy(tax) {
            if (state.selected[tax]) {
                delete state.selected[tax];
            }
        }

        function selectedToPayload() {
            var out = {};
            $.each(state.selected, function (tax, map) {
                var ids = [];
                $.each(map, function (termId, on) {
                    if (on) ids.push(parseInt(termId, 10));
                });
                if (ids.length) out[tax] = ids;
            });
            return out;
        }

        function syncUI() {
            // checkboxes
            $root
            .find('input[type="checkbox"][data-taxonomy][data-term-id]')
            .each(function () {
                var $el = $(this);
                var tax = String($el.data("taxonomy"));
                var termId = String($el.data("term-id"));
                var on = !!(state.selected[tax] && state.selected[tax][termId]);
                $el.prop("checked", on);
            });

            $root
            .find('input[type="checkbox"][data-taxonomy][data-show-all="true"]')
            .each(function () {
                var $el = $(this);
                var tax = String($el.data("taxonomy"));
                var hasSelection = false;

                if (state.selected[tax]) {
                    $.each(state.selected[tax], function (_termId, on) {
                        if (on) {
                            hasSelection = true;
                            return false;
                        }
                    });
                }

                $el.prop("checked", !hasSelection);
            });

            // chips
            $root
            .find("button.chip[data-taxonomy][data-term-id]")
            .each(function () {
                var $el = $(this);
                var tax = String($el.data("taxonomy"));
                var termId = String($el.data("term-id"));
                var on = !!(state.selected[tax] && state.selected[tax][termId]);


                $el.attr("aria-pressed", on ? "true" : "false");
                $el.toggleClass("active", on);
            });

            if ($searchInput.length) {
                $searchInput.val(state.search);
            }
        }

        function renderPagination() {
            if (!$pagination.length) return;

            if (state.maxPages <= 1) {
                $pagination.empty().hide();
                return;
            }

            var html = "";
            var prevDisabled = state.page <= 1;
            var nextDisabled = state.page >= state.maxPages;

            html += '<button type="button" class="pagination-button previous" data-page="' + (state.page - 1) + '"' + (prevDisabled ? ' disabled aria-disabled="true"' : "") + '><div></div></button>';

            for (var page = 1; page <= state.maxPages; page += 1) {
                html += '<button type="button" class="pagination-button' + (page === state.page ? " active" : "") + '" data-page="' + page + '"' + (page === state.page ? ' aria-current="page"' : "") + ">" + page + "</button>";
            }

            html += '<button type="button" class="pagination-button next" data-page="' + (state.page + 1) + '"' + (nextDisabled ? ' disabled aria-disabled="true"' : "") + '><div></div></button>';

            $pagination.html(html).show();
        }

        function loadList(resetGrid) {
            if (state.loading) return $.Deferred().resolve().promise();
            state.loading = true;

            if (resetGrid) {
                state.page = 1;
                $grid.empty();
            }

            return $.ajax({
                url: restBase + "/list",
                method: "POST",
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify({
                    post_type: settings.postType || "post",
                    page: state.page,
                    per_page: settings.perPage || 8,
                    filters: selectedToPayload(),
                    excluded_taxonomy: state.excluded,
                    exclude_ids: [],
                    search: state.search,
                }),
            })
            .then(function (data) {
                state.maxPages = data.max_pages || 1;

                $grid.html(data.html || "");
                renderPagination();
            })
            .always(function () {
                state.loading = false;
            });
        }

        // checkbox change
        $root.on(
            "change",
            'input[type="checkbox"][data-taxonomy][data-term-id]',
            function () {
                var $el = $(this);
                var tax = String($el.data("taxonomy"));

                setSelected(
                    tax,
                    String($el.data("term-id")),
                    $el.is(":checked")
                );

                if (tax === "category") {
                    syncUI();
                }

                writeSelectedToUrl(true);
                loadList(true);
            }
        );

        $root.on(
            "change",
            'input[type="checkbox"][data-taxonomy][data-show-all="true"]',
            function () {
                var $el = $(this);
                var tax = String($el.data("taxonomy"));

                if ($el.is(":checked")) {
                    clearTaxonomy(tax);
                    syncUI();
                    writeSelectedToUrl(true);
                    loadList(true);
                } else {
                    syncUI();
                }
            }
        );

        // chip toggle
        $root.on("click", "button.chip[data-taxonomy][data-term-id]", function (e) {
            e.preventDefault();
            var $el = $(this);
            var tax = String($el.data("taxonomy"));
            var termId = String($el.data("term-id"));
            var on = !!(state.selected[tax] && state.selected[tax][termId]);

            setSelected(tax, termId, !on);

            // Unfocus uniquement quand on désactive
            if (on) {
                this.blur();
            }

            syncUI();
            writeSelectedToUrl(true);
            loadList(true);
        });

        var searchDebounceTimer = null;

        $root.on("input", ".listing__search-input", function () {
            state.search = String($(this).val() || "").trim();

            if (searchDebounceTimer) {
                window.clearTimeout(searchDebounceTimer);
            }

            searchDebounceTimer = window.setTimeout(function () {
                writeSelectedToUrl(true);
                loadList(true);
            }, 300);
        });

        $root.on("click", ".pagination-button[data-page]", function (e) {
            e.preventDefault();
            if ($(this).is("[disabled]")) return;

            var nextPage = parseInt($(this).attr("data-page"), 10);
            if (!nextPage || nextPage < 1 || nextPage > state.maxPages || nextPage === state.page) {
                return;
            }

            state.page = nextPage;
            loadList(false);
        });

        // reset
        $btnReset.on("click", function (e) {
            e.preventDefault();
            clearSelected();
            state.search = "";
            syncUI();
            writeSelectedToUrl(false);
            loadList(true);
            this.blur();
        });

        // Handle back/forward buttons
        window.addEventListener("popstate", function () {
            state.selected = readSelectedFromUrl();
            state.search = readSearchFromUrl();
            state.excluded = readExcludedFromUrl();
            syncUI();
            loadList(true);
        });

        // initial load: apply URL -> UI -> list (and normalize URL)
        state.selected = readSelectedFromUrl();
        state.search = readSearchFromUrl();
        state.excluded = readExcludedFromUrl();
        syncUI();
        writeSelectedToUrl(false);
        loadList(true);
    }

    $(window).on("elementor/frontend/init", function () {
        if (window.elementorFrontend && window.elementorFrontend.hooks) {
            window.elementorFrontend.hooks.addAction(
                "frontend/element_ready/listing-posts.default",
                function ($scope) {
                    var $root = $scope.find(".listing[data-settings]").first();
                    if ($root.length) initListing($root);
                }
            );
        }
    });
})(jQuery);
